"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.SelectOption = function (_a) {
    var isFocused = _a.isFocused, isSelected = _a.isSelected, className = _a.className, children = _a.children, restProps = tslib_1.__rest(_a, ["isFocused", "isSelected", "className", "children"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default("gd-list-item", "gd-select-option", isSelected && "gd-select-option-is-selected", isFocused && "gd-select-option-is-focused s-select-item-focused", className) }, restProps), children));
};
//# sourceMappingURL=SelectOption.js.map